<template>
  <div class="history-dialog">
    <ul class="history-list">
      <li :key="index" class="history-item" v-for="(item, index) in history">
        <div class="item-line">
          <div
            class="item-refresh"
            v-if="item.discount_refresh"
          >{{transify['CHANGE_TRY_YOUR_LUCK']}}</div>
          <div
            class="item-refresh"
            v-else-if="item.pool_refresh"
          >{{transify['CHANGE_POOL_REFRESH']}}</div>
          <div class="item-cover" v-else>
            <item class="item-image" v-bind="$bus.formatData(item)" />
            <c-marquee class="item-name-wrapper" :is-ar="$bus.isAr">{{item.item_name}}</c-marquee>
          </div>
          <div
            class="item-discount"
            v-show="!item.discount_refresh&&!item.pool_refresh"
          >{{item.discount}}% <span class="item-discount-off">{{ transify['CHANGE_OFF'] }}</span></div>
          <div class="item-cost gem">{{item.cost||transify['CHANGE_FREE']}}</div>
          <div class="item-time">{{getTime(item.created_at)}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  import { getTime, mapState } from '@/utils/assist'
  import Item from '@/components/item/item'
  export default {
    name: 'History',
    components: {
      Item
    },
    props: {
      history: Array
    },
    methods: {
      getTime
    },
    computed: {
      ...mapState(['transify'])
    }
  }
</script>
<style lang="scss">
  .history-dialog {
    @include px2res(padding, 0, 25);
  }
  .history-list {
    @include px2res(padding, 0, 30);
    @include px2res(height, 350);
    overflow-y: auto;
    overflow-x: hidden;
    .history-item {
      border-bottom: 1px solid #5532a3;
      .item-line {
        @include px2res(height, 130);
        @include flexrc;
        justify-content: flex-end;
        @include px2res(font-size, 28);
        color: #d1e9ed;
        .item-cover {
          @include flexrc;
          justify-content: flex-start;
          .item-name-wrapper {
            @include px2res(width, 120);
            @include px2res(margin-left, 14);
            text-align: left;
          }
        }
        .item-refresh {
          @include px2res(width, 150+120+14+84);
          text-align: left;
        }
        .item-discount {
          @include px2res(padding-left, 20);
          @include px2res(width, 150);
          text-align: left;
        }
        .item-cost {
          @include px2res(padding-left, 20);
          @include px2res(width, 135);
          text-align: left;
        }
        .item-time {
          flex: 1;
        }
      }
      .item-image {
        @include px2res(width, 84);
        @include px2res(height, 84);
      }
      .itemobj-num {
        @include px2res(font-size, 24);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/history/history.vue